var exports = {
  "x": "button__DJgyKv",
  "s": "expanded__Xlydih",
};

module.exports = exports;
